import { videoChaptersManifest } from './video-chapters.ts';

/** One chapter of a produced video: its card's title and start on the timeline. */
export interface VideoChapter {
  title: string;
  /** Chapter number from the card, when it carries one. */
  number?: number;
  /** Chapter start on the video's timeline, in milliseconds. */
  startMs: number;
}

const manifest: Record<string, VideoChapter[]> = videoChaptersManifest;

/**
 * Chapter list for a rendered video composition id, e.g.
 * `product-demo-software-light` — or `null` before one has been synced.
 * Produced by the marketing subtitle pass (`out/<id>-chapters.json`) and
 * folded into the committed manifest by `marketing:asset:push`, the same flow as
 * `media()` — see docs/media-storage.md.
 */
export function videoChapters(id: string): VideoChapter[] | null {
  const chapters = manifest[id];
  return chapters !== undefined && chapters.length > 0 ? chapters : null;
}
